var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarningXl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 61,
    viewBox: "0 0 75 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.9851 43.7481L34.7754 19.7178H40.2189L39.3117 43.7481H35.9851ZM35.0778 51.4501V46.8289H39.9165V51.4501H35.0778Z",
    fill: "#F5DF4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4618 61H4.53434C4.23192 61 3.9295 61 3.9295 60.6919L-0.00195312 53.298C-0.00195312 52.9899 -0.00195312 52.6818 -0.00195312 52.6818L32.9618 0.308081C33.2642 0 33.2642 0 33.5666 0H41.1271C41.4295 0 41.7319 0 41.7319 0.308081L74.6956 52.6818C74.6956 52.9899 74.9981 53.298 74.6956 53.298L70.7642 60.3838C70.7642 60.6919 70.7642 61 70.4618 61ZM5.5 59H69L72.1835 52.9899L40.8247 2.5404H33.869L2.51014 52.9899L5.5 59Z",
    fill: "#F5DF4D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningXl);
export default __webpack_public_path__ + "static/media/warning-xl.1df12676.svg";
export { ForwardRef as ReactComponent };